import { IMotorsportsGpStandings } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidGpPodiumList } from "./typeguards";
import { GpPodiumListQuery } from "../types";
import { CreateGpPodiumListWidgetInputSchema } from "cdk/graphql";
import { WidgetError, ErrorName } from "../../../utils/errors";
import { intcmpMap } from "../../../utils/intcmp";
import { transformGrandPrixSessions } from './session-transformer';
import { ISession } from '../../../types/session';
import { IGpInfo } from '../../../types/grand-prix';
import { IGrandPrixSessions } from '../../../types/grand-prix-sessions';

const trackingData = intcmpMap.podiumList;

const PODIUM_LIST_COUNT = 3;

export const getCustomGpName = (gpInfo: IGpInfo): string | '' => gpInfo?.customGpName ?? '';

export const getPodiumList = (gpArray: IGrandPrixSessions) =>
  gpArray.map((gp) => {
    return { ...gp, rows: gp.rows.slice(0, PODIUM_LIST_COUNT) };
  });

export default (obj: GpPodiumListQuery):IMotorsportsGpStandings => {
  
  if (isValidGpPodiumList(obj)) {
    CreateGpPodiumListWidgetInputSchema().parse( obj.data.getGpPodiumListWidget,  { reportInput: true });
    const { grandPrixList } = obj.data.getGpPodiumListWidget;
    
    type GrandPrixList = NonNullable<typeof grandPrixList>;
    type GrandPrix = NonNullable<GrandPrixList[number]>;

    const standings = grandPrixList!
      .filter((grandPrix): grandPrix is GrandPrix => grandPrix != null)
      .map((grandPrix: GrandPrix ) => {
          const { gpInfo, session } = grandPrix;
          
          const gpName = getCustomGpName(gpInfo as IGpInfo);

          const { gpPageUrl, gpCrosslink } = gpInfo as IGpInfo;     

          const grandPrixSessions = session as ISession;

          return transformGrandPrixSessions(grandPrixSessions ? [grandPrixSessions] : [], trackingData, gpName, gpPageUrl, gpCrosslink) ?? [];
      })
      .reduce((acc, curVal) => acc?.concat(curVal!), []); 
      

      const podiumList = {
        standings: getPodiumList(standings) as IMotorsportsGpStandings["standings"],
        openedItems: 0,
        trackingData: {
          intcmp: 'skysport_sportsdata_risultati-tutti_null',
        },
      };
      
      return podiumList;

  } else {
    throw new WidgetError<ErrorName>({
      name: "NO_VALID_DATA",
      message: "Invalid transformer input, Error in GpPodiumListQuery object",
      data: obj,
    });
  }
};

